import React from 'react'

import Navbar from '../components/navbar'
import AboutOne from '../components/about-one'
import Footer from '../components/footer'
import ScrollToTop from '../components/scroll-to-top'
import HomeBanner from '../components/home-banner'
import icon1 from '../assets/images/branding/icon2.png'
import icon2 from '../assets/images/branding/icon7.png'
import icon3 from '../assets/images/branding/icon8.png'
import icon4 from '../assets/images/branding/icon9.png'
import Alianzas from '../components/alianzas'
import SliderPromos from '../components/slider-promos'
import Blogfeatured from '../components/blogfeatured'
import Instalacionesfeatured from '../components/instalacionesfeatured'
import Tecnologiafeatured from '../components/tecnologiafeatured'
import Paquetesfeatured from '../components/paquetesfeatured'
import { Helmet } from 'react-helmet-async'
import metadataimage from '../assets/images/hero/ss4.jpg'

export default function Index() {
    const basedomain = process.env.REACT_APP_BASE_URL;
    return (
        <>
            <Helmet>
                <title>Hospital Aranda de La Parra | León Guanajuato</title>
                <meta name="description" content="En Hospital Aranda de la Parra, combinamos calidez humana con atención médica de primer nivel, ofreciendo un servicio cercano y oportuno." />
                <meta property="og:title" content="Hospital Aranda de La Parra | León Guanajuato" />
                <meta property="og:description" content="En Hospital Aranda de la Parra, combinamos calidez humana con atención médica de primer nivel, ofreciendo un servicio cercano y oportuno." />
                <meta property="og:image" content={`${basedomain}${metadataimage}`} />
                <meta property="og:url" content={`${basedomain}`} />
                <meta property="og:type" content="website" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Hospital Aranda de La Parra | León Guanajuato" />
                <meta name="twitter:description" content="En Hospital Aranda de la Parra, combinamos calidez humana con atención médica de primer nivel, ofreciendo un servicio cercano y oportuno." />
                <meta name="twitter:image" content={`${basedomain}${metadataimage}`} />
                <meta itemprop="name" content="Hospital Aranda de La Parra | León Guanajuato" />
                <meta itemprop="description" content="En Hospital Aranda de la Parra, combinamos calidez humana con atención médica de primer nivel, ofreciendo un servicio cercano y oportuno." />
                <meta itemprop="image" content={`${basedomain}${metadataimage}`} />
            </Helmet>
            <Navbar />
            <Navbar />
            <HomeBanner />

            <section className="section bg-inverted">
                <div className="container">
                    <AboutOne />
                </div>
            </section>
            <section className="section">
                <div className="container d-none d-md-block">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="section-title text-center mb-4 pb-2">
                                <h4 className="title mb-3">Promociones</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        <SliderPromos />
                    </div>
                    <div className="row justify-content-center mt-5">
                        <div className="col-12 text-center">
                            <a href="/paquetes" className="btn btn-link primary text-dark fs-6">Ver más <i className="mdi mdi-arrow-right"></i></a>
                        </div>
                    </div>
                </div>
            </section>
            {/* <section className="section">
                <div className="container mt-10 d-none d-md-block">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="section-title text-center mb-4 pb-2">
                                <h4 className="title mb-3">Nuestras Principales Especialidades Clínicas</h4>
                                <p className="text-muted para-desc mx-auto mb-0">Valoramos cada vida humana confiada a nuestras manos y trabajamos constantemente para superar las expectativas de nuestros pacientes.</p>
                            </div>
                        </div>
                    </div>

                    <Feature />

                    <div className="row justify-content-center mt-4">
                        <div className="col-12 text-center">
                            <a href="/servicios" className="btn btn-link primary fs-6">Navegar servicios <i className="mdi mdi-arrow-right"></i></a>
                        </div>
                    </div>
                </div>
            </section> */}
            <section className="section bg-inverted">
                <div className="container mb-5">
                    <div className="row justify-content-center">
                        <div className="col-sm-3 col-4 text-center">
                            <img src={icon1} className="img-fluid w-50 mx-auto" alt="" />
                        </div>
                    </div>
                </div>
                <div className="container mt-50 mt-60">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="section-title text-center mb-4 pb-2">
                                <h4 className="title mb-3">Instalaciones y Servicios</h4>

                                <p className="text-muted para-desc mx-auto mb-0">
                                    Contamos con instalaciones modernas y servicios médicos especializados que brindan atención integral y de calidad a nuestros pacientes. Cada área está diseñada para ofrecer comodidad y seguridad en todas las etapas del cuidado. A continuación, presentamos nuestras principales especialidades y servicios.
                                </p>

                            </div>
                        </div>
                    </div>
                    <Instalacionesfeatured />

                    <div className="row justify-content-center mt-4">
                        <div className="col-12 text-center">
                            <a href="/servicios" className="btn btn-link primary text-success fs-6">Ver más <i className="mdi mdi-arrow-right"></i></a>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section">
                <div className="container mb-5">
                    <div className="row justify-content-center">
                        <div className="col-sm-3 col-4 text-center">
                            <img src={icon2} className="img-fluid w-50 mx-auto" alt="" />
                        </div>
                    </div>
                </div>
                <div className="container mt-50 mt-60">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="section-title text-center mb-4 pb-2">
                                <h4 className="title mb-3">Tecnología y Equipamiento</h4>

                                <p className="text-muted para-desc mx-auto mb-0">
                                    En nuestro hospital, integramos tecnología avanzada y equipos de última generación para asegurar diagnósticos precisos y tratamientos efectivos. Nos comprometemos a mantenernos a la vanguardia en innovación médica para brindar la mejor atención posible a nuestros pacientes.
                                </p>
                            </div>
                        </div>
                    </div>
                    <Tecnologiafeatured />

                    <div className="row justify-content-center mt-4">
                        <div className="col-12 text-center">
                            <a href="/tecnologia" className="btn btn-link primary text-secondary fs-6">Ver más <i className="mdi mdi-arrow-right"></i></a>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section bg-dark">
                <div className="container mb-5">
                    <div className="row justify-content-center">
                        <div className="col-sm-3 col-4 text-center">
                            <img src={icon3} className="img-fluid w-50 mx-auto" alt="" />
                        </div>
                    </div>
                </div>
                <div className="container mt-50 mt-60">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="section-title text-center mb-4 pb-2">
                                <h4 className="title text-light mb-3">Paquetes</h4>

                                <p className="text-muted para-desc mx-auto mb-0">
                                    Nuestros paquetes médicos han sido diseñados para brindar atención integral y accesible, adaptada a diversas necesidades de salud. Cada paquete incluye servicios y procedimientos clave, seleccionados por nuestros especialistas para ofrecer un cuidado completo y preventivo. Explora nuestras opciones y encuentra el paquete que mejor se ajuste a tus requerimientos de salud y bienestar.
                                </p>
                            </div>
                        </div>
                    </div>
                    <Paquetesfeatured />

                    <div className="row justify-content-center mt-4">
                        <div className="col-12 text-center">
                            <a href="/paquetes" className="btn btn-link text-light fs-6">Ver más <i className="mdi mdi-arrow-right"></i></a>
                        </div>
                    </div>
                </div>
            </section>

            <section className="section bg-inverted">
                <div className="container mb-5">
                    <div className="row justify-content-center">
                        <div className="col-sm-3 col-4 text-center">
                            <img src={icon4} className="img-fluid w-50 mx-auto" alt="" />
                        </div>
                    </div>
                </div>
                <div className="container mt-50 mt-60">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="section-title text-center mb-4 pb-2">
                                <h4 className="title mb-3">Blog</h4>
                                <p className="text-muted para-desc mx-auto mb-0">
                                    Nuestro blog es un espacio dedicado a compartir información valiosa sobre salud, bienestar y avances médicos.
                                </p>
                            </div>
                        </div>
                    </div>
                    <Blogfeatured />

                    <div className="row justify-content-center mt-4">
                        <div className="col-12 text-center">
                            <a href="/blog" className="btn btn-link text-pink fs-6">Ver más <i className="mdi mdi-arrow-right"></i></a>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section">
                <div className="container mt-50 mt-60">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="section-title text-center mb-4 pb-2">
                                <h4 className="title mb-3">Alianzas</h4>
                                <p className="text-muted para-desc mx-auto mb-0">
                                    Estamos comprometidos con la excelencia en el cuidado de la salud y el bienestar de nuestros pacientes. Para lograrlo, hemos establecido alianzas estratégicas con instituciones y profesionales de la salud, con el fin de brindar una atención integral y de calidad. A continuación, presentamos algunas de nuestras alianzas más destacadas.
                                </p>
                            </div>
                        </div>
                    </div>
                    <Alianzas />
                </div>
            </section>
            <Footer />
            <ScrollToTop />
        </>
    )
}
